<template>
  <v-container>
    <v-row>
      <v-col
        v-for="(item, index) in storeErrors"
        :key="index"
        cols="12"
      >
        <v-alert
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
        >
          {{ item[0] }}
        </v-alert>
      </v-col>
      <v-col
        cols="4"
      >
        <v-text-field
          v-model="supplierId"
          label="Supplier ID"
          required
        />
      </v-col>
      <v-col
        cols="8"
      >
        <v-text-field
          v-model="name"
          label="Name"
          required
        />
      </v-col>
      <v-col
        cols="4"
      >
        <v-text-field
          v-model="subscriptionDate"
          label="Date Partnered"
          type="date"
          required
        />
      </v-col>
      <v-col
        cols="4"
      >
        <v-text-field
          v-model="contactNo1"
          label="Contact No. 1"
        />
      </v-col>
      <v-col
        cols="4"
      >
        <v-text-field
          v-model="contactNo2"
          label="Contact No. 2"
        />
      </v-col>
      <v-col
        cols="12"
      >
        <v-text-field
          v-model="address"
          label="Address"
        />
      </v-col>
      <v-col
        cols="2"
        align-self="end"
      >
        <v-btn
          color="blue"
          :loading="storing"
          @click="initStore"
        >
          Save
        </v-btn>
      </v-col>
      <v-col
        cols="2"
        align-self="end"
      >
        <v-btn
          color="red"
          dark
          @click="closeDialog"
        >
          Close
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  export default {
    name: 'VCreateSupplier',
    data () {
      return {
        supplierId: null,
        name: null,
        subscriptionDate: null,
        address: null,
        contactNo1: null,
        contactNo2: null,
      }
    },
    computed: {
      ...mapState({
        storeSuccess: state => state.supplier.storeSuccess,
        storing: state => state.supplier.storing,
        storeErrors: state => state.supplier.storeErrors,
      }),
    },
    watch: {
      storeSuccess (val) {
        if (val) {
          this.closeDialog()
        }
      },
    },
    methods: {
      ...mapActions({
        store: 'supplier/store',
      }),
      closeDialog () {
        this.$emit('close-dialog')
      },
      initStore () {
        const data = {
          id: this.supplierId,
          name: this.name,
          subscription_date: this.subscriptionDate,
          address: this.address,
          contact_no_1: this.contactNo1,
          contact_no_2: this.contactNo2,
        }
        this.store(data)
      },
    },
  }
</script>
